var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h32v32H0z"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#A5ADBD",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.801 8.93c0-2.06-1.67-3.73-3.732-3.73H6.732A3.732 3.732 0 0 0 3 8.93v16.134c0 2.061 1.67 3.732 3.732 3.732h18.337a3.731 3.731 0 0 0 3.732-3.732V8.931z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "M10.503 3v4.399M21.298 3v4.399"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#A5ADBD",
    d: "M9.067 15.783H12.1V12.75H9.067zM9.067 22.067H12.1v-3.034H9.067zM14.483 15.783h3.034V12.75h-3.034zM14.483 22.067h3.034v-3.034h-3.034zM19.9 15.783h3.033V12.75H19.9zM19.9 22.067h3.033v-3.034H19.9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.0c7d83631bbe48d07462a93b48c02c8b.svg";
export { ForwardRef as ReactComponent };